import { render } from "./BlackBox.vue?vue&type=template&id=d19e2ca0"
import script from "./BlackBox.vue?vue&type=script&lang=js"
export * from "./BlackBox.vue?vue&type=script&lang=js"

import "./BlackBox.vue?vue&type=style&index=0&id=d19e2ca0&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__